import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSupportMembers = createAsyncThunk(
    'supportPortalMembers/fetchData',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(`api/SupportRequests/members`);
        return response;
    }
);
